import { render, staticRenderFns } from "./WillPensionCollectingYN.vue?vue&type=template&id=13bf80f1"
import script from "./WillPensionCollectingYN.vue?vue&type=script&lang=js"
export * from "./WillPensionCollectingYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports